import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtMXN } from "@/lib/format";
import { Gift } from "lucide-react";

export default function AdminGiftCards() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/gift-cards").then((r) => {
      setCards(r.data);
      setLoading(false);
    });
  }, []);

  const totalSold = cards.filter(c => c.payment_status === "paid").reduce((s, c) => s + c.initial_amount, 0);
  const totalRedeemed = cards.filter(c => c.payment_status === "paid").reduce((s, c) => s + (c.initial_amount - c.balance), 0);
  const totalOutstanding = cards.filter(c => c.payment_status === "paid").reduce((s, c) => s + c.balance, 0);

  return (
    <div className="p-8 md:p-12" data-testid="admin-giftcards">
      <div className="mb-8">
        <div className="text-xs tracking-[0.35em] uppercase text-arre-red mb-2">⟡ Admin</div>
        <h1 className="font-display text-4xl md:text-5xl tracking-wider uppercase text-white leading-none">Tarjetas de regalo</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <StatCard label="Vendido total" value={fmtMXN(totalSold)} />
        <StatCard label="Redimido" value={fmtMXN(totalRedeemed)} />
        <StatCard label="Saldo en circulación" value={fmtMXN(totalOutstanding)} highlight />
      </div>
      <div className="bg-arre-surface border border-arre-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-arre-border text-[10px] tracking-[0.2em] uppercase text-white/50">
              <th className="text-left p-4">Código</th>
              <th className="text-left p-4">Comprador</th>
              <th className="text-left p-4">Destinatario</th>
              <th className="text-left p-4">Monto</th>
              <th className="text-left p-4">Saldo</th>
              <th className="text-left p-4">Pago</th>
              <th className="text-left p-4">Fecha</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan="7" className="p-8 text-center text-white/50">Cargando...</td></tr>}
            {!loading && cards.length === 0 && (
              <tr><td colSpan="7" className="p-10 text-center">
                <Gift className="w-10 h-10 text-white/20 mx-auto mb-3" />
                <div className="text-white/50">Aún no hay tarjetas vendidas, compare.</div>
              </td></tr>
            )}
            {cards.map((c) => (
              <tr key={c.id} className="border-b border-arre-border/50" data-testid={`giftcard-${c.code}`}>
                <td className="p-4 font-display text-sm text-white tracking-wider">{c.code}</td>
                <td className="p-4 text-white/80">
                  <div>{c.buyer_name}</div>
                  <div className="text-xs text-white/50">{c.buyer_email}</div>
                </td>
                <td className="p-4 text-white/70">{c.recipient_name || "—"}</td>
                <td className="p-4 text-white font-display">{fmtMXN(c.initial_amount)}</td>
                <td className={`p-4 font-display ${c.balance === c.initial_amount ? "text-white" : c.balance > 0 ? "text-arre-red" : "text-white/40"}`}>
                  {fmtMXN(c.balance || 0)}
                </td>
                <td className="p-4">
                  <span className={c.payment_status === "paid" ? "text-green-400" : "text-white/40"}>
                    {c.payment_status === "paid" ? "Pagada" : "Pendiente"}
                  </span>
                </td>
                <td className="p-4 text-white/60 text-xs">
                  {new Date(c.created_at).toLocaleDateString("es-MX")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function StatCard({ label, value, highlight }) {
  return (
    <div className={`bg-arre-surface border p-6 ${highlight ? "border-arre-red" : "border-arre-border"}`}>
      <div className="text-[10px] tracking-[0.25em] uppercase text-white/50">{label}</div>
      <div className="font-display text-3xl tracking-wider text-white mt-2">{value}</div>
    </div>
  );
}
